exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.historyList_filter {\n  background: #fff;\n  position: relative;\n  font-size: 0.2133rem;\n}\n.historyList_filter /deep/ .weui-cells {\n  margin-top: 0;\n}\n.historyList_filter .buttons {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  border-top: 1px solid #f2f2f2;\n}\n.historyList_filter .buttons .button {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n  height: 1.1733rem;\n  line-height: 1.1733rem;\n  text-align: center;\n}\n.historyList_filter .buttons .button:first-child {\n  border-right: 1px solid #f2f2f2;\n}\n", ""]);

// exports
